import { useTranslation } from "react-i18next";
import type { BrandSummary } from "@/api";
import { deleteBrandMutation, listBrandsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for a brand. */
export function useDeleteBrand(onDeleted?: () => void) {
  const { t } = useTranslation("brands");
  return useDeleteEntity<BrandSummary>({
    mutation: deleteBrandMutation(),
    listQueryKey: listBrandsQueryKey,
    pathFor: (b) => ({ brand_uuid: b.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
